import React from 'react';
import { DiagnosticsOverviewTab } from './DiagnosticsOverview';
import { DiagnosticsProblemsTab } from './DiagnosticsProblems';

const Diagnostics = () => {
  return <DiagnosticsProblemsTab />;
};

export const ProblemsTab = () => {
  return <DiagnosticsProblemsTab />;
};

export const AlertsTab = () => {
  return <DiagnosticsOverviewTab />;
};

export default Diagnostics;
